<i class="material-icons sidebar-platform-icon" *ngIf="platform == 'android'"
  [ngStyle]="{'font-size': iconSize || '12px', 'width': iconSize || '12px', 'height': iconSize || '12px'}">android</i>
<i class="material-icons sidebar-platform-icon" *ngIf="platform == 'web'"
  [ngStyle]="{'font-size': iconSize || '12px', 'width': iconSize || '12px', 'height': iconSize || '12px'}">desktop_windows</i>
<i class="material-icons sidebar-platform-icon" *ngIf="platform == 'be'"
  [ngStyle]="{'font-size': iconSize || '12px', 'width': iconSize || '12px', 'height': iconSize || '12px'}">dns</i>
<svg-icon-sprite [src]="'assets/images/svgIconsSprite.svg#ios'" [width]="iconSize || '12px'" *ngIf="platform == 'ios'">
</svg-icon-sprite>
